import actions from "./actions";

const initState = {
  schools: null,
  grades: null,
  roles: null,
  users: null,
  loading: false,
  notifications: [],
  isCompleted: false,
};

export default function notificationReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_NOTI_CONFIGS_SUCCESS:
      return {
        ...state,
        schools: action.schools,
        grades: action.grades,
        roles: action.roles,
      };

    case actions.SEARCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.users,
      };

    case actions.SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    case actions.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.notifications,
        isCompleted: false,
      };

    case actions.SET_COMPLETED:
      return {
        ...state,
        isCompleted: true,
      };

    case actions.RESET:
      return {
        ...state,
        devices: null, // ⚠️ If `devices` isn't in the initial state, this will just add it
      };

    default:
      return state;
  }
}
